/* O+ launch-list sign-up logic. Copied from the "A closer look" sign-up page (assets/teaser.js, sign-up part): same endpoint, payload and messages.
   Works for several forms on one page (each .oplus-signup[data-oplus-signup] is wired separately).
   The two Klaviyo ids are set in snippets/oplus-signup.liquid (data-site-id / data-list-id). While either is blank NOTHING is sent anywhere. */
(function () {
  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  const store = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* private mode: fine */ } }
  };

  function wire(root) {
    if (root.dataset.osBound) return;
    root.dataset.osBound = '1';
    const CFG = Object.assign({
      klaviyoSiteId: root.dataset.siteId || '',
      klaviyoListId: root.dataset.listId || '',
      thanksUrl: root.dataset.thanksUrl || '',
      source: root.dataset.source || 'Closer look sign-up page'
    }, window.OPLUS_CLOSER_LOOK || {});

    const $ = s => root.querySelector(s);
    const form = $('[data-signup]');
    if (!form) return;
    const input = $('[data-email]'), msg = $('[data-msg]'), btn = $('[data-submit]'), label = $('[data-submit-label]'), hp = $('[data-hp]');

    // where people came from: ?src=ig-dm | ig-bio | web | store-qr, plus any utm_* tags on the link
    const params = new URLSearchParams(location.search);
    const meta = {};
    ['src', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].forEach(k => {
      const v = params.get(k) || store.get('oplus-cl-' + k);
      if (v) { meta[k === 'src' ? 'signup_src' : k] = v.slice(0, 120); store.set('oplus-cl-' + k, v.slice(0, 120)); }
    });

    const fail = text => {
      form.classList.add('is-invalid');
      msg.textContent = text;
      input.setAttribute('aria-invalid', 'true');
      input.focus();
    };
    input.addEventListener('input', () => {
      if (!form.classList.contains('is-invalid')) return;
      form.classList.remove('is-invalid'); msg.textContent = ''; input.removeAttribute('aria-invalid');
    });

    async function subscribe(email) {
      if (!CFG.klaviyoSiteId || !CFG.klaviyoListId) {
        console.warn('[O+ sign-up] Klaviyo is not connected yet: this sign-up was not sent anywhere.');
        await new Promise(r => setTimeout(r, 600));
        return;
      }
      const res = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(CFG.klaviyoSiteId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2025-01-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: CFG.source,
              profile: { data: { type: 'profile', attributes: {
                email,
                properties: meta,
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              } } }
            },
            relationships: { list: { data: { type: 'list', id: CFG.klaviyoListId } } }
          }
        })
      });
      if (!res.ok) throw new Error('Klaviyo ' + res.status);
    }

    const succeed = () => {
      if (CFG.thanksUrl) { location.href = CFG.thanksUrl; return; }
      form.hidden = true;
      const done = $('[data-done]'); done.hidden = false;
    };

    let busy = false;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (busy) return;
      const email = input.value.trim();
      if (!email) return fail('Please enter your email address.');
      if (!EMAIL.test(email)) return fail('That email address doesn’t look right. Please check it and try again.');
      if (hp && hp.value) { succeed(); return; }   // a bot filled the honeypot: show it the success state and send nothing

      busy = true;
      btn.setAttribute('aria-busy', 'true'); label.textContent = 'Sending';
      msg.textContent = '';
      try {
        await subscribe(email);
        store.set('oplus-cl-email', email);
        succeed();
      } catch (err) {
        busy = false;
        btn.removeAttribute('aria-busy'); label.textContent = 'Try again';
        fail('Something went wrong on our side. Please try again in a moment.');
      }
    });
  }

  function init() { document.querySelectorAll('[data-oplus-signup]').forEach(wire); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
